<div class="h-100 d-flex flex-column" *ngIf="!produtoSelecionado">

  <!-- Barra de Busca e Categorias -->
  <div class="p-2 bg-white border-bottom sticky-top">
    <div class="mb-2">
      <input type="text" class="form-control form-control-lg" placeholder="Buscar produto (Nome ou Código)..."
             [(ngModel)]="buscaTermo" (input)="filtrarProdutos()">
    </div>

    <div class="d-flex flex-wrap pb-2" style="padding: 20px 10px;">
      <button *ngFor="let cat of categorias"
              class="btn btn-rounded mr-2 mb-2"
              [class.btn-primary]="categoriaSelecionada?.id === cat.id"
              [class.btn-outline-secondary]="categoriaSelecionada?.id !== cat.id"
              (click)="selecionarCategoria(cat)">
        {{cat.nome}}
      </button>
    </div>
  </div>

  <!-- Lista de Produtos -->
  <div class="flex-grow-1 overflow-auto p-2 bg-light">
    <div class="row no-gutters">
      <div class="col-6 col-md-4 col-lg-3 p-1" *ngFor="let prod of produtosFiltrados">
        <div class="card h-100 shadow-sm border-0 produto-card" (click)="selecionarProduto(prod)">
          <!-- Imagem -->
          <div class="card-img-top" style="height: 120px; overflow: hidden;" *ngIf="prod.imagens && prod.imagens.length > 0">
             <img [src]="'https://fibo.meucardapio.ai/images/empresa/' + prod.imagens[0].linkImagem" class="w-100 h-100" style="object-fit: cover;" alt="{{prod.nome}}">
          </div>
          <div class="card-img-top bg-light d-flex align-items-center justify-content-center" style="height: 120px;" *ngIf="!prod.imagens || prod.imagens.length === 0">
             <i class="fa fa-image fa-2x text-muted"></i>
          </div>

          <div class="card-body p-2 d-flex flex-column justify-content-between">
            <div>
              <h6 class="card-title mb-1 text-truncate" title="{{prod.nome}}">{{prod.nome}}</h6>
            </div>

            <div class="d-flex justify-content-between align-items-end">
              <span class="font-weight-bold text-primary">
                {{ (prod.novoPreco ? prod.novoPreco : prod.preco) | currency:'BRL' }}
              </span>
              <button class="btn btn-sm btn-outline-primary rounded-circle">
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 text-center mt-5" *ngIf="produtosFiltrados.length === 0">
        <p class="text-muted">Nenhum produto encontrado.</p>
      </div>
    </div>
  </div>
</div>

<!-- Detalhes do Produto (Seleção de Adicionais/Quantidade) -->
<div class="h-100 d-flex flex-column bg-white" *ngIf="produtoSelecionado">
  <div class="p-3 border-bottom d-flex align-items-center">
    <button class="btn btn-light btn-rounded mr-3" (click)="cancelarSelecao()">
      <i class="fa fa-arrow-left"></i>
    </button>
    <h5 class="m-0">{{produtoSelecionado.nome}}</h5>
  </div>

  <div class="flex-grow-1 overflow-auto p-3">
    <form>
      <!-- Quantidade / Peso -->
      <div class="row">
        <div class="col-12 mb-3 text-center" *ngIf="exibirUnidade(produtoSelecionado)">
          <span class="text-muted font-14">{{produtoSelecionado.preco | currency:'BRL'}} por KG</span>
        </div>

        <ng-container *ngIf="!exibirUnidade(produtoSelecionado)">
          <div class="col-12">
            <div class="form-group">
              <label>Quantidade</label>
              <div class="input-group input-group-lg">
                <div class="input-group-prepend">
                  <button class="btn btn-outline-secondary" type="button" (click)="itemPedido.qtde = itemPedido.qtde - 1" [disabled]="itemPedido.qtde <= 1">-</button>
                </div>
                <input type="number" class="form-control text-center" [(ngModel)]="itemPedido.qtde" name="qtde">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" (click)="itemPedido.qtde = itemPedido.qtde + 1">+</button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="exibirUnidade(produtoSelecionado)">
           <!-- Lógica de Peso (simplificada do original) -->
           <div class="col-12">
             <label>Peso ({{produtoSelecionado.unidadeMedida?.sigla}})</label>
             <input type="number" class="form-control form-control-lg" [(ngModel)]="itemPedido.qtde" name="peso">
           </div>
        </ng-container>
      </div>

      <!-- Adicionais -->
      <div *ngIf="produtoSelecionado.tamanhos">
        <app-adicionais-customizados #adicionaisCustomizados
                                     (alterouTamanho)="onAlterouTamanho($event)"
                                     [itemPedido]="itemPedido"
                                     [produto]="produtoSelecionado">
        </app-adicionais-customizados>
      </div>

      <div *ngFor="let campoAdicional of produtoSelecionado.camposAdicionais">
        <app-site-campo-adicional #adicionalComponent
                                  [campoAdicional]="campoAdicional"
                                  [itemPedido]="itemPedido"
                                  [posicao]="campoAdicional.posicao"
                                  (onDesmarcouOpcao)="desmarcouNovaOpcao($event)"
                                  (onMarcouOpcao)="escolheuNovaOpcao($event)">
        </app-site-campo-adicional>
      </div>

      <!-- Observação -->
      <div class="form-group mt-3">
        <label>Observação</label>
        <textarea class="form-control" rows="2" [(ngModel)]="itemPedido.observacao" name="obs" placeholder="Ex: Sem cebola..."></textarea>
      </div>

      <div class="alert alert-danger" *ngIf="mensagemErro">{{mensagemErro}}</div>

    </form>
  </div>

  <div class="p-3 border-top">
    <button class="btn btn-success btn-block btn-lg" (click)="editando ? atualizeProduto() : adicionarProduto()">
      <span *ngIf="!editando">ADICIONAR - {{ itemPedido.total | currency:'BRL' }}</span>
      <span *ngIf="editando">ATUALIZAR - {{ itemPedido.total | currency:'BRL' }}</span>
    </button>
  </div>
</div>
